var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flatpickr-wrapper"},[_c('div',{staticClass:"input-container"},[_c('input',_vm._b({ref:"flatpickr",staticClass:"dates-input",attrs:{"readonly":""}},'input',_vm.$attrs,false)),_vm._v(" "),_c('v-icon',{staticClass:"calendar-icon",attrs:{"color":"success"},on:{"click":_vm.openFlatpickr}},[_vm._v("event")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2127c29a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/app-date-flat.vue
// module id = 1577
// module chunks = 1 19 20 27 39